import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { reactI18nextModule } from 'react-i18next';

let locale = window.navigator.language.toLowerCase();
locale = locale.replace('-', '_');

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(reactI18nextModule)
    .init({
        fallbackLng: false,
        lng: locale,

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',
        nsSeparator: false,
        keySeparator: false,

        debug: false,

        interpolation: {
            escapeValue: false, // not needed for react!!
        },

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        },

        react: {
            wait: true,
            withRef: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        }
    });


export default i18n;



// WEBPACK FOOTER //
// ./src/config/i18n.js